import { z } from 'zod';

import { membershipStatusValues } from '../tenancy/membership.dto.js';
import type {
  EmployeeAssignableUserDto,
  ListEmployeeAssignableUsersRequest,
  ListEmployeeAssignableUsersResponse,
} from './employee-users.dto.js';

export const EmployeeAssignableUserSchema: z.ZodType<EmployeeAssignableUserDto> = z.object({
  userId: z.uuid(),
  email: z.string().trim().pipe(z.email()),
  status: z.enum(membershipStatusValues),
});

export const ListEmployeeAssignableUsersRequestSchema: z.ZodType<ListEmployeeAssignableUsersRequest> =
  z.object({
    companyId: z.uuid(),
    status: z.enum(membershipStatusValues).optional(),
    page: z.number().int().min(1).optional(),
    pageSize: z.number().int().min(1).max(200).optional(),
  });

export const ListEmployeeAssignableUsersResponseSchema: z.ZodType<ListEmployeeAssignableUsersResponse> =
  z.object({
    items: z.array(EmployeeAssignableUserSchema),
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1).max(200),
    total: z.number().int().min(0),
  });
